<script setup lang="ts">
import {formatting, Models, useOrderViewContext} from '@hantera/portal-app'

const props = defineProps<{
  capture: Models.Graph.PaymentCapture
}>()

const orderViewContext = useOrderViewContext()

</script>

<template>
  <div class="capture box-content p">
    <div
      class="capture__state"
      :style="`background-color: var(--state-${capture.state})`"
      :title="capture.state"
    ></div>

    <div>
      <div class="capture__payment-number">{{capture.payment.paymentNumber}}</div>
      <div class="timestamp">{{formatting.dateTime(capture.createdAt)}}</div>
      <div v-if="!capture.remainingAmount.eq(0)">
        Remaining: {{formatting.currency(capture.remainingAmount, orderViewContext.state.currencyCode)}}
      </div>
      {{(''/* TODO Add app view for PSP apps to show additional info and links */)}}
    </div>

    <div class="capture__balance">
      {{formatting.currency(capture.amount, orderViewContext.state.currencyCode)}}
    </div>
  </div>
</template>

<style scoped>

.capture {
  position: relative;
  
  padding-left: 10px;
  
  display: grid;
  grid-template-columns: auto max-content;
}

.capture__state {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 5px;
  border-radius: 5px;
}

.timestamp {
  font-size: 12px;
  color: hsl(var(--color-20));
}


</style>